/*
 * Routinae - self-build routine: the running count and total.
 *
 * Progressive enhancement over the real <form> inside <routine-add>. The
 * native contract (radios named items[n][id], one POST to /cart/add) works
 * with this file absent; everything here is a courtesy:
 *
 *   - the status line becomes "2 of 3 steps chosen - EUR38,90"
 *   - the confirm button is aria-disabled while nothing is picked, which
 *     <routine-add> already respects in its submit handler. This is a
 *     courtesy, not a gate (GOTCHAS.md #21): with JS off the native submit
 *     happens and the server answers honestly.
 *
 * Money formatting mirrors money() in routina-finder-ui.js - the format
 * string arrives from shop.money_format via a data attribute, so the
 * currency display cannot drift from the rest of the shop.
 */
(function () {
  'use strict';

  function money(cents, format) {
    var v = (cents || 0) / 100;
    var f = format || '€{{amount}}';
    function amount(dec, thou) {
      var s = v.toFixed(2).split('.');
      var whole = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return whole + dec + s[1];
    }
    return f
      .replace(/\{\{\s*amount\s*\}\}/g, amount('.', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount(',', '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(v)))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(v)))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amount('.', "'"));
  }

  function fill(tpl, vars) {
    return String(tpl || '').replace(/%(\w+)%/g, function (m, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-sb-root]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.sbBooted) return;
      root.dataset.sbBooted = '1';

      var form = root.querySelector('form');
      var status = root.querySelector('[data-sb-status]');
      var button = form && form.querySelector('button[type="submit"]');
      // status/button are absent on browse-only pages (show_confirm off);
      // the type gate and fit filtering must still run there.
      if (!form) return;

      var groups = {};
      Array.prototype.forEach.call(form.querySelectorAll('input[type="radio"]'), function (r) {
        groups[r.name] = true;
      });
      var total = Object.keys(groups).length;

      function update() {
        var checked = form.querySelectorAll('input[type="radio"]:checked');
        var sum = 0;
        Array.prototype.forEach.call(checked, function (r) {
          sum += parseInt(r.getAttribute('data-sb-price'), 10) || 0;
        });
        if (!status || !button) return;
        if (checked.length === 0) {
          status.textContent = root.dataset.sbHint || '';
          button.setAttribute('aria-disabled', 'true');
        } else {
          status.textContent = '';
          var text = fill(root.dataset.sbProgress, {
            picked: checked.length,
            count: total,
            total: money(sum, root.dataset.sbMoney)
          });
          // The price gets a heavier face; split on the money value.
          var parts = text.split(money(sum, root.dataset.sbMoney));
          status.appendChild(document.createTextNode(parts[0]));
          var b = document.createElement('b');
          b.textContent = money(sum, root.dataset.sbMoney);
          status.appendChild(b);
          if (parts[1]) status.appendChild(document.createTextNode(parts[1]));
          button.removeAttribute('aria-disabled');
        }
      }

      form.addEventListener('change', function (ev) {
        if (ev.target && ev.target.matches('input[type="radio"]')) update();
      });

      /* The skin-type gate (Beyond Korea's dynamic mode). JS-only behaviour
         on top of the same native form: the grid hides until a type is
         chosen, then each option shows only if its data-sb-fit list carries
         the type. An option with no fit list fits everyone. A pick that a
         type-switch hides is unchecked so the basket can never carry a
         product the visitor was told does not fit them. With JS off, the
         question is inert and every option is visible - the form still
         posts, the server still answers. */
      var typeGate = root.querySelector('[data-sb-type]');
      if (typeGate) {
        var gated = root.querySelectorAll('[data-sb-gated]');
        Array.prototype.forEach.call(gated, function (g) { g.hidden = true; });

        typeGate.addEventListener('change', function (ev) {
          if (!ev.target || !ev.target.matches('input[type="radio"]')) return;
          var t = ev.target.value;
          Array.prototype.forEach.call(form.querySelectorAll('.sb__opt'), function (opt) {
            var fit = opt.getAttribute('data-sb-fit') || '';
            var show = !fit || fit.split(' ').indexOf(t) !== -1;
            opt.hidden = !show;
            if (!show) {
              var r = opt.querySelector('input[type="radio"]');
              if (r && r.checked) r.checked = false;
            }
          });
          Array.prototype.forEach.call(gated, function (g) { g.hidden = false; });
          update();
        });
      }
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
